<template>
    <div
        :id="$attrs.id ? `form-group-${$attrs.id}` : undefined"
        class="form-group"
        :class="{
            row: row,
            'v-center': row,
        }"
    >
        <label
            v-if="$scopedSlots.label"
            :for="$attrs.id ? `form-control-label-${$attrs.id}` : htmUniqueId"
            class="form-control-label"
            :class="{
                'col-sm-3': row,
                'stretch': !row,
            }"
        >
            <slot name="label"></slot>
        </label>
        <div
            :id="$attrs.id ? `form-input-group-${$attrs.id}` : undefined"
            class="input-group input-group-merge"
            :class="{
                'col-sm-9': row,
            }"
        >
            <slot name="content" :htm-unique-id="$attrs.id ? `form-control-label-${$attrs.id}` : htmUniqueId"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'RowLabeled',
        inheritAttrs: false,
        props: {
            row: {
                type: Boolean,
                required: true,
            },
        },
        data() {
            return {
                htmUniqueId: `id-${Math.random()}`,
            };
        },
    };
</script>

<style scoped lang="scss">
    .v-center {
        display: flex;
        align-items: center;
    }

    .stretch {
        width: 100%;
    }
</style>
